jQuery(document).ready(function ($) {
  $(".wp-block-sivananda-blocks-renting-like-galleries").each(function () {
    const
      // DOM
      $bodyHtml = $('body, html'),
      $rentingListBlock = $(this),
      $galleryGallerySwipers = $rentingListBlock.find(".gallery-swiper"),
      $interestedInButtons = $rentingListBlock.find('.gallery-details button'),
      $form = $rentingListBlock.find('form'),
      $gallerySelect = $form.find('select'),

      // helper funcs
      setUpgallerySelect = () => {
        const names = $rentingListBlock.find('.gallery-for-rent h2').map((index, element) => $(element).text()).toArray();

        names.forEach((name, index) => {
          $gallerySelect.append(`<option value='${name}'>${name}</option>`);
        });

        $gallerySelect.selectWoo({
          minimumResultsForSearch: -1,
          width: '100%'
        });
      },
      setUpSwiperGalleries = () => {
        $galleryGallerySwipers.each(function (index, element) {
          $galleryGallerySwiper = $(element);

          new Swiper(element, {
            loop: true,
            navigation: {
              prevEl: $galleryGallerySwiper.find('.fa-chevron-left')[0],
              nextEl: $galleryGallerySwiper.find('.fa-chevron-right')[0],
            }
          });
        });
      },
      setUpClickOnInterestedButton = () => {
        $interestedInButtons.on('click', function () {
          const galleryName = $(this).closest('.gallery-for-rent').find('h2').text();

          $gallerySelect.val(galleryName).trigger('change');

          // scroll to form
          $bodyHtml.animate({
            scrollTop: $form.offset().top - 140
          }, 100, 'swing');
        });
      };

    setUpgallerySelect();
    setUpSwiperGalleries();
    setUpClickOnInterestedButton();
  });
});
